import { CatHeading } from '@blocks-react/components/Heading';
import { SuccessErrorToast } from '../../common/success-error-toast';

type ServiceRecommendationToastProp = {
  toastErrorHeading: string;
  toastErrorContent: string;
};

export const ServiceRecommendationToast = ({
  toastErrorHeading,
  toastErrorContent
}: ServiceRecommendationToastProp) => {
  return (
    <SuccessErrorToast
      variant={'error'}
      toastPosition={{
        verticalPosition: 'top',
        horizontalPosition: 'center'
      }}
    >
      <div className="d-flex flex-column">
        <CatHeading variant="label">{toastErrorHeading}</CatHeading>
        <CatHeading variant="body-sm">{toastErrorContent}</CatHeading>
      </div>
    </SuccessErrorToast>
  );
};
